import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import formatDate from 'utils/formatDate';

import { fetchBranchDetails } from 'modules/outletDetails';
import LoadingOverlay from 'components/LoadingOverlay';

class OutletDetails extends Component {
  componentDidMount() {
    const { id } = this.props.match.params;
    const { isLoading, dispatch } = this.props;

    // Do not fetch request if request already sent
    if (!isLoading) {
      dispatch(fetchBranchDetails(id));
    }
  }

  renderData() {
    const { data } = this.props;
console.log(data);
    return (
      <div>
        <div className="entry-header">
          <h2 className="block-title">
            {data.name}
          </h2>
        </div>

        <div className="grid">
          <div className="grid__item large--eight-twelfths">
            {data.featured_image ? (
              <div
                className="product-item__image"
                style={{
                  backgroundImage: `url('${data.featured_image}')`,
                  height: 300,
                }}
              >
                <img src={data.featured_image} alt={data.name} />
              </div>
            ) : null}

            <div className="product-item__inner">
              <div className="product-item__head">
                <div className="product-item__discount">
                  {data.countdown_end ? (
                    <span>
                      {data.discount}
                      <span className="percent">%</span>
                    </span>
                  ) : null}
                </div>
              </div>

              {data.countdown_end ? (
                <div className="product-item__discount-end">
                  <i className="icon-tags" />
                  Diskon berlaku sampai:
                  {' '}
                  {formatDate(data.countdown_end.timestamp)}
                </div>
              ) : null}

              <div className="product-item__location mb-30">
                <i className="icon-location" />
                <div className="product-item__location-name">
                  {data.address}
                </div>
              </div>

              <div className="entry-content" dangerouslySetInnerHTML={{ __html: data.promo_info }} />
            </div>
          </div>

          <div className="grid__item large--four-twelfths">
              {data.id ? (
                <QRCode value={`${data.id}`} size={256} bgColor="#ffffff" fgColor="#000000" level="L" />
              ) : null}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, isLoaded } = this.props;
    const showLoading = isLoading ? 'show' : '';

    return (
      <div className={`form-wrapper content-wrapper ${showLoading}`} style={{ maxWidth: 800 }}>
        <div className="form-wrapper__inner">
          {isLoaded === true && this.renderData()}
        </div>

        <LoadingOverlay />
      </div>
    );
  }
}

const mapStateToProps = ({ outletDetails }) => ({
  ...outletDetails,
});

export default connect(mapStateToProps)(OutletDetails);



// WEBPACK FOOTER //
// ./src/pages/OutletDetails/index.js